"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTE = exports.paramsSchema = void 0;
var yup = __importStar(require("yup"));
var xss_1 = __importDefault(require("xss"));
var constants_1 = require("../../../constants");
var xssSafeString = function (message) {
    if (message === void 0) { message = 'Input contains potentially harmful content'; }
    return yup.string().test('is-xss-safe', message, function (value) {
        var cleanValue = (0, xss_1.default)(value !== null && value !== void 0 ? value : '');
        var isSafe = cleanValue === (value || '');
        return isSafe;
    });
};
exports.paramsSchema = yup.object().shape({
    soldier: yup.object().shape({
        name: xssSafeString().required('Required'),
        battle: yup
            .object()
            .shape({
            value: xssSafeString().required('Required'),
            title: xssSafeString().required('Required'),
            category: xssSafeString().required('Required'),
        })
            .nullable(),
        division: yup
            .object()
            .shape({
            value: xssSafeString().required('Required'),
            title: xssSafeString().required('Required'),
        })
            .nullable(),
        unit: yup
            .object()
            .shape({
            value: xssSafeString().required('Required'),
            title: xssSafeString().required('Required'),
            category: xssSafeString().required('Required'),
        })
            .nullable(),
        soldier: yup
            .array()
            .of(yup.object().shape({
            value: xssSafeString().required('Required'),
            name: xssSafeString().required('Required'),
            rank: xssSafeString().required('Required'),
        }))
            .default([]),
    }),
    memory: yup
        .object()
        .shape({
        story: xssSafeString().required('Required'),
        photos: yup
            .array()
            .of(yup
            .object()
            .shape({
            state: yup.string().oneOf(['default', 'uploading', 'success', 'error']).required('Required'),
            url: yup.string().url().optional(),
        })
            .required('Required'))
            .required('Required'),
        confirmation: yup.boolean().oneOf([true]),
    })
        .required('Required'),
    contact: yup
        .object()
        .shape({
        name: xssSafeString().required('Required'),
        email: xssSafeString().email(),
        phone: xssSafeString().required('Required'),
        confirmation: yup.boolean().oneOf([true]),
    })
        .required('Required'),
});
exports.ROUTE = constants_1.routes.CLIENT_FORM_SUBMIT;
//# sourceMappingURL=params.js.map